var React = require('react');

function MinusIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.25879 1.87109H16.5333","stroke":"#F36B13","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

MinusIconInline.defaultProps = {"width":"18","height":"3","viewBox":"0 0 18 3","fill":"none"};

module.exports = MinusIconInline;

MinusIconInline.default = MinusIconInline;
